import { jsx } from "react/jsx-runtime";
import AntSpin from "antd/es/spin";
import classnames from "../../utils/classnames.js";
import './Loader.css';/* empty css            */
const Loader = ({ className, wrapperClassName, ...props }) => {
  return /* @__PURE__ */ jsx(
    AntSpin,
    {
      className: classnames("perxis-auto-loader", className),
      wrapperClassName: classnames("perxis-auto-loader-wrapper", wrapperClassName),
      ...props
    }
  );
};
export {
  Loader as default
};
//# sourceMappingURL=Loader.js.map
